import { toast } from "react-toastify";
import i18n from "../../config/lang";
import { startShowLoader, stopShowLoader } from "../loader";
import { ADDTIONAL_DRIVER_CODE, GET_AGREEMENT_FILE, POST_AGREEMENT_EMAIL, POST_CHECKIN, POST_CREATE_AGREEMENT, POST_PAYMENT, POST_REQUEST_SIGNATURE_URL } from "../../utilities/constants";
import { drawSignature, setSignatureSize } from "../../utilities";
import { axiosClient } from "../../config";
import { resetAgreement, setAddCheckInAttempts, setAddPaymentAttempts, setAgreement, setAgreementFile, setCheckInInfo, setInitializeDebt, setPaymentInfo, setSignature } from "./agreementSlice";
import { resetSearch } from "../../app/searchApp/store/searchRezSlice";
import { resetReservation } from "../reservation/reservationSlice";
import { resetQuotation } from "../../app/quotationApp/store/quotationSlice";
import { resetAD } from "../../app/quotationApp/AdditionalDriverApp/store/additionalDriverSlice";
import { startSetLocalData } from "../localService";

const t = i18n.t;
export const startEditClientSignature = ({ officeId, answered }) => {
    return async( dispatch, getState ) => {
        let localService = getState().localService;

        if (Object.keys(localService).length == 0) {
            await dispatch( startSetLocalData() );
            localService = getState().localService;
        }

        try {
            const { status: statusResponse, data: response } = await axiosClient.post(POST_REQUEST_SIGNATURE_URL,
                {
                    PinPadID: localService.PinPadPOIID,
                    Office: officeId,
                    SignatureOnly: answered
                },
                {
                    timeout: 90000
                }
            )
            .catch(e => e);

            if (statusResponse != 200 || response?.type != "success") {
                toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
                return false;
            }

            const signatureData = response.data;
            const { answer1, answer2} = signatureData;

            const renterSignature = JSON.parse(signatureData.renterSignature)?.additionalData?.responseData;
            const initialsSignature = JSON.parse(signatureData.initialsSignature)?.additionalData?.responseData;


            const renterSignaturePoints = !!renterSignature ? JSON.parse(renterSignature).signature.data: null;

            const initialsSignaturePoints = !!initialsSignature ? JSON.parse(initialsSignature).signature.data: null;

            const imageSize = setSignatureSize(renterSignaturePoints);

            const svgDescription = drawSignature(renterSignaturePoints, imageSize);

            dispatch( setSignature({
                renterSignaturePoints,
                initialsSignaturePoints,
                svgDescription,
                answers: {
                    answer1,
                    answer2
                }
            }) );

        } catch (error) {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
        }
    }
}

export const startInitializeAgreement = () => {
    return async( dispatch ) => {

    }
}

export const startInitializeDebtAgreement = ({ totalDebt, subtotal, currency, reservationCode }) => {
    return async( dispatch ) => {
        try {
            dispatch( startShowLoader() );
            dispatch( setInitializeDebt({ totalDebt, subtotal, currency, reservationCode }) );
            dispatch( stopShowLoader() );
            return true;
        } catch (error) {
            dispatch( stopShowLoader() );
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}

export const startCreateAgreement = () => {
    return async( dispatch, getState ) => {
        dispatch( startShowLoader() );

        const { calculatedQuotation: quotation, additionalExtras } = getState().quotation;
        const { clientReservation, originalReservation: { pricing: { rate: { breakdown, extraDayPrice }, discounts } } } = getState().reservation;
        const signature = getState().agreement.signature;
        const { list: additionalDriverList } = getState().additionalDriver;

        const { status: statusResponse, data: response } = await axiosClient.post(POST_CREATE_AGREEMENT, {
            CurrencyId: quotation.currencyInfo.currencyId,
            ReservationId: quotation.reservationInfo.id,
            ExchangeRate: quotation.currencyInfo.currencyExchange,
            RenterSignature: JSON.stringify(signature.renterSignaturePoints),
            Answer1: JSON.stringify(signature.answers.answer1.inputData),
            Answer2: JSON.stringify(signature.answers.answer2.inputData),
            Extras: getState().quotation.upgradeQuotation.confirmation == true ?  [...additionalExtras.map(x=> ({ code: x.code, itemQty: x.itemQty })), { code: "UP", itemQty: 1 }]: additionalExtras.map(x => ({ code: x.code, itemQty: x.itemQty })),
            ExtrasEdited: getState().quotation.upgradeQuotation.confirmation == true ? [{code: "UP", price: getState().quotation.upgradeQuotation.data.pricePerDay}]: [],
            RateEdited: JSON.stringify(breakdown),
            ExtraDayPriceEdited: extraDayPrice,
            Client: {
                ClientId: clientReservation.cientId,
                CustomerType: 0,
                FirstName: clientReservation.firstName,
                LastName: clientReservation.lastName,
                DateOfBirth: clientReservation.dateOfBirth,
                Email: clientReservation.email,
                Address: {
                    AddressId: clientReservation.address.addressId,
                    CountryId: clientReservation.address.countryId,
                    State: clientReservation.address.state,
                    Street1: clientReservation.address.street,
                    Street2: clientReservation.address.street2,
                    ZipCode: clientReservation.address.zipCode,
                    City: clientReservation.address.city,
                    AddressTypeId: clientReservation.address.client
                },
                TaxData: clientReservation.taxData.rfc != "" ? {
                    RFC: clientReservation.taxData.rfc,
                    RegimenFiscal: clientReservation.taxData.taxRegimeId,
                    RazonSocial: clientReservation.taxData.razonSocial,
                    CodigoPostal: clientReservation.taxData.codigoPostal,
                    ClientType: clientReservation.taxData.clientType
                }: null,
                Documents: {
                    ID: clientReservation.documents.id.id,
                    LicenseId: clientReservation.documents.license.id
                }
            },
            AdditionalDrivers: !!additionalExtras.find(x => x.code == ADDTIONAL_DRIVER_CODE) ? additionalDriverList.map(ad => ({ ...ad, signaturePoints: !!ad.signature ? JSON.stringify(ad.signature) : null })): null,
            PromoCode: discounts?.discountBy || null
        })
        .catch(e => e);

        dispatch( stopShowLoader() );
        if (statusResponse != 200 || response?.type != "success") {
            toast.error(response.message);
            return false;
        }

        const { agreementId: id, noConfirmation: agreementCode, pricing, class: classes  } = response.data;

        await dispatch( startGetAgreementFile({ agreementId: id }) );

        dispatch( setAgreement({ id, agreementCode, quotation: pricing, classes: { ...classes, smallImage: classes.urlSmallImage } }) );
        return true;
    }
}

export const startGetAgreementFile = ({ agreementId }) => {
    return async( dispatch ) => {
        dispatch( startShowLoader() );

        const { status: statusResponse, data: response } = await axiosClient.post(GET_AGREEMENT_FILE, {
            agreementId
        })
        .catch(e => e);

        dispatch( stopShowLoader() );
        if (statusResponse != 200 || response?.type != "success") {
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
        }

        dispatch( setAgreementFile(response.data) );
    }
}

export const startSendAgreementToEmail = () => {
    return async( dispatch, getState ) => {
        dispatch( startShowLoader() );

        const agreementId = getState().agreement.id;
        const email = getState().reservation.clientReservation.email;

        const { status: statusResponse, data: response } = await axiosClient.post(POST_AGREEMENT_EMAIL, {
            agreementId,
            emails: email,
        })
        .catch(e => e);

        dispatch( stopShowLoader() );

        if (statusResponse != 200 || response?.type != "success") {
            dispatch( setReservation(null) );
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }

        toast.success(t('Success.email_sent', 'Agreement sent to email successfully'));

        return true;
    }
}

export const startCheckInPayment = ({ amount }) => {
    return async( dispatch, getState ) => {
        const { id: agreementId } = getState().agreement;
        const { calculatedQuotation: { currencyInfo: { currencyId } } } = getState().quotation;
        let localService = getState().localService;

        if (Object.keys(localService).length == 0) {
            await dispatch( startSetLocalData() );
            localService = getState().localService;
        }

        const { status: statusResponse, data: response } = await axiosClient.post(POST_CHECKIN, {
            AgreementId: agreementId,
            CurrencyId: currencyId,
            TotalPayment: amount,
            PinPadPOIID: localService.PinPadPOIID
        })
        .catch(e => e);


        if (statusResponse != 200 || response?.type != "success") {
            toast.error(response.error);
            dispatch( setAddCheckInAttempts() );
            return;
        }

        dispatch( setCheckInInfo( response.data ) );
    }
}

export const startRentPayment = ({ paymentMethod }) => {
    return async( dispatch, getState ) => {
        const { id: agreementId, quotation: { total: totalPayment } } = getState().agreement;
        const { calculatedQuotation: { currencyInfo: { currencyId } } } = getState().quotation;
        let localService = getState().localService;

        if (Object.keys(localService).length == 0) {
            await dispatch( startSetLocalData() );
            localService = getState().localService;
        }

        const { status: statusResponse, data: response } = await axiosClient.post(POST_PAYMENT, {
            AgreementId: agreementId,
            PaymentMethod: paymentMethod,
            CurrencyId: currencyId,
            TotalPayment: totalPayment,
            PinPadPOIID: localService.PinPadPOIID
        })
        .catch(e => e);

        if (statusResponse != 200 || response?.type != "success") {
            toast.error(response.message);
            dispatch( setAddPaymentAttempts() );
            return;
        }

        dispatch( setPaymentInfo( response.data ) );
    }
}

export const startResetAgreement = () => {
    return async ( dispatch ) => {
        try {
            dispatch( resetAgreement() );
        } catch (error) {
            console.error(error);
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}

export const startResetAllBusinessSlices = () => {
    return async ( dispatch ) => {
        try {
            dispatch( resetSearch() );
            dispatch( resetReservation() );
            dispatch( resetQuotation() );
            dispatch( resetAD() );
            dispatch( resetAgreement() );
        } catch (error) {
            console.error(error);
            toast.error(t('Error.unexpected_error_occurred', 'An unexpected error occurred, please try again later.'));
            return false;
        }
    }
}
